export default "__VITE_ASSET__a02188e1__"